module.exports = __webpack_public_path__ + "img/address-bg.7399cb79.png";